import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Chip, Icon, TextField, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { getTouchMdUploadsAPI } from 'api';
import { BackdropCircular } from 'components';


const useStyles = makeStyles(() => ({
  success: {
    backgroundColor: '#009900',
    color: '#fff'
  },
  failed: {
    backgroundColor: '#cc0000',
    color: '#fff'
  },
}));


const TouchMdDetails = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { touchMdUploads, touchMdTotalCount, touchMdUploadsLoading } = useSelector((state: IReduxState) => state.admin);
  const [dataUploads, setDataUploads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [emailParam, setEmailParam] = useState('');
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    getTouchMdUploadsAPI({
      dispatch,
      page: currentPage,
      limit: pageSize,
      email: emailParam
    });
  }, [
    currentPage,
    pageSize,
    emailParam
  ]);

  useEffect(() => {
    if (touchMdUploads.length) {
      setDataUploads(touchMdUploads.map((item) => {
        const {firstname, lastname, email } = item.customer;
        const createdAt = new Date(item.createdAt).toLocaleString().replace(',', '');
        const error = item.isUploaded === false ? (item.error?.message || 'No info') : null;
        const status = item.isUploaded ? 'Success' : 'Failed';

        return {
          ...item,
          firstname,
          lastname,
          email,
          createdAt,
          error,
          status
        };
      }));
    } else {
      setDataUploads([]);
    }
  }, [touchMdUploads]);

  const columns = [
    {
      name: 'firstname',
      label: 'First Name',
    },
    {
      name: 'lastname',
      label: 'Last Name',
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        setCellHeaderProps: () => ({ style: { width: '220px' } }),
      }
    },
    {
      name: 'createdAt',
      label: 'Created at',
      options: {
        setCellHeaderProps: () => ({ style: { whiteSpace: 'nowrap' } }),
      }
    },
    {
      name: 'pdfFileName',
      label: 'PDF Name',
      options: {
        setCellHeaderProps: () => ({ style: { width: '150px' } }),
      }
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        setCellHeaderProps: () => ({ style: { width: '100px' } }),
        customBodyRenderLite: (dataIndex) => {
          const {isUploaded, status} = dataUploads[dataIndex];
          return (
            <Chip
              variant="outlined"
              label={status}
              className={isUploaded ? classes.success : classes.failed}
            />
          );
        },
      }
    },
    {
      name: 'error',
      label: 'Error type',
      options: {
        setCellHeaderProps: () => ({ style: { width: '200px' } }),
      }
    },
  ];

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page + 1);
  };

  const onSearch = () => {
    setEmailParam(searchValue);
    setCurrentPage(1);
    setPageSize(20);
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="flex">
        <div className="w-220 mr-5">
          <TextField
            fullWidth
            variant="outlined"
            onChange={(event) => setSearchValue(event.target.value)}
            InputProps={{
              startAdornment: (
                <Icon
                  className="text-muted"
                  fontSize="small"
                >
                  search
                </Icon>
              )
            }}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={onSearch}
        >
          Search by Email
        </Button>
      </div>
      <MUIDataTable
        className="mt-10 px-5"
        title="TouchMD sync details"
        data={dataUploads}
        columns={columns}
        options={{
          filterType: 'textField',
          selectableRows: 'none',
          rowsPerPageOptions: [20, 40, 80, 100, 200],
          serverSide: true,
          search: false,
          filter: false,
          download: false,
          print: false,
          viewColumns: false,
          rowsPerPage: pageSize,
          page: currentPage - 1,
          count: touchMdTotalCount,
          onChangePage: handlePageChange,
          onChangeRowsPerPage: handleRowsPerPageChange,
        }}
      />
      <BackdropCircular loading={touchMdUploadsLoading} />
    </div>
  );
};

export default TouchMdDetails;
